import Model from './model.js';
import axios from 'axios';
import Log from 'lib/log';
const log = Log();

export default class Subscription extends Model {
    urlRoot() {
        return '';
    }

    url() {
        if (!this.id) {
            return this.user.url() + `/subscription`;
        }

        return `/Subscriptions/${this.id}`;
    }

    initialize(attributes, {user} = {}) {
        this.idAttribute = 'objectId';

        if (!user) {
            throw new Error(
                `We need an user to instantiate a subscription model`
            );
        }

        this.user = user;

        this.invoices = [];

        return super.initialize(...arguments);
    }

    constraints() {
        return {
            discountLimit: {
                numericality: {
                    onlyInteger: true,
                    greaterThanOrEqualTo: 0,
                    message: `^Discount limit must be integers greater than 0`
                }
            }
        };
    }

    setPlan(plan) {
        return axios.post(
            this.finalUrl() + '/setPlan',
            {plan},
            {headers: {'Authorization': app.user.getAccessToken().id}}
        ).then(() => this.fetch())
        .catch(err => {
            throw err.response.data.error;
        });
    }

    setDiscount() {
        if (this.isValid()) {
            return axios.post(
                this.finalUrl() + '/setDiscount',
                {
                    couponCode: this.get('couponCode'),
                    isDiscountLimited: this.get('isDiscountLimited'),
                    discountLimit: this.get('discountLimit')
                },
                {headers: {'Authorization': app.user.getAccessToken().id}}
            )
            .catch(err => {
                throw err.response.data.error;
            });
        } else {
            return Promise.reject(this.validationError);
        }
    }

    updateStatus() {
        return axios.post(
            `${this.finalUrl()}/updateStatus`,
            {},
            {headers: {'Authorization': app.user.getAccessToken().id}}
        ).then(() => this.fetch())
        .catch(err => {
            throw err.response.data.error;
        });
    }

    generateInvoices() {
        return axios.post(
            `${this.finalUrl()}/generateInvoices`,
            {},
            {headers: {'Authorization': app.user.getAccessToken().id}}
        ).then(() => this)
        .catch(err => {
            throw err.response.data.error;
        });
    }

    adjustYearlyInvoice() {
        return axios.post(
            `${this.finalUrl()}/adjustYearlyInvoice`,
            {},
            {headers: {'Authorization': app.user.getAccessToken().id}}
        ).then(() => this)
        .catch(err => {
            throw err.response.data.error;
        });
    }

    toggleInvoicing() {
        return axios.post(
            `${this.finalUrl()}/toggleInvoicing`,
            {},
            {headers: {'Authorization': app.user.getAccessToken().id}}
        ).then(() => this.fetch()).then(() => this)
        .catch(err => {
            throw err.response.data.error;
        });
    }

    updateDetails() {
        return axios.post(
            `${this.finalUrl()}/updateDetails`,
            {},
            {headers: {'Authorization': app.user.getAccessToken().id}}
        ).then(() => this)
        .catch(err => {
            throw err.response.data.error;
        });
    }

    listInvoices() {
        return axios.get(
            `${this.finalUrl()}/invoices`,
            {headers: {'Authorization': app.user.getAccessToken().id}}
        ).then(r => {
            this.invoices = r.data.results || [];
            return this.invoices;
        })
        .catch(err => {
            log.error(err.response.data.error);
            // 20210318 return previous invoice data if failed
            return this.invoices;
        });
    }

    invoiceDownloadUrl(id) {
        return `${this.finalUrl()}/invoicePdf/${id}?` +
            `access_token=${app.user.getAccessToken().id}`;
    }

    onlinePayment(invoiceId) {
        const id = app.subscription.id;

        return axios.post(
            `${this.baseUrl()}/subscriptions/${id}/onlinePayment`,
            {
                id: id,
                invoiceId: invoiceId
            },
            {headers: {'Authorization': app.user.getAccessToken().id}}
        ).then(r => r.data)
        .catch(err => {
            throw err.response.data.error;
        });
    }

    save() {
        // 20210710 make sure custom prices are sent as numbers.
        if (this.get('customBasePrice') !== undefined) {
            this.set(
                'customBasePrice',
                parseFloat(this.get('customBasePrice')) || 0
            );
        }
        if (this.get('customEmployeePrice') !== undefined) {
            this.set(
                'customEmployeePrice',
                parseFloat(this.get('customEmployeePrice')) || 0
            );
        }

        this.set({
            isDiscountLimited: !!this.get('isDiscountLimited'),
            discountLimit: parseInt(this.get('discountLimit'), 10)
        });

        return (app.user.isAdmin() ? this.setDiscount() : Promise.resolve())
            .then(() => super.save(...arguments));
    }
}



// WEBPACK FOOTER //
// ./app/new-models/subscription.js